import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';
import { Icon } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { RoundButton } from 'components/lib/UI';
import util from 'utils/utils';
import * as UI from './UI';

const UserAvatar = styled.div`
  position: absolute;
  background-color:white;
  border-radius:50% !important;
  height:  80px;
  width: 80px;
  right:0;
  left:0;
  bottom: 0;
  top:0;
  margin: auto;
  ${({ user }) => ((user.profile?.avatar || (!user.profile.firstName || !user.profile.lastName)) ? `
    background-size: cover;
    background-position: center center;
    background-image: url(${util.avatarUrl(user)});
    border: 1px solid white;
  ` : `
    background-color: #184258fc;
    > span {
      display: block;
      line-height: 80px;
      color: white;
      font-weight: bold;
      text-align: center;
      font-size: 18px;
    }
  `)}
`;

const VideoContainer = styled.div`
  position: relative;
  background-color: black;
  height: inherit;
  margin: auto;
  max-width: 500px;
  border-radius: 4px;
  margin-top: 5px;
  margin-bottom: 5px;
`;

const VideoDiv = styled.video`
  height: inherit;
  max-width: 100%;
  transform: scale(-1, 1) !important;
  ${({ minimised, talking }) => (!minimised && !talking) && 'border-radius: 4px;'}
`;

const NameContainer = styled.div`
  position: absolute;
  bottom: 0px;
  padding: 2px;
  border-radius: 2px;
  background-color: rgb(15 21 25 / 99%);
  > span {
    color: white;
    font-size: 12px;
  }
`;

const TalkingIcon = styled(Icon)`
  position: absolute;
  z-index: 100;
  background-color: rgb(31 100 160 / 98%) !important;
  color: white;
  right: 0px;
  top: 4px;
`;

const VideoPreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

const LobbyScreen = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

const ThreadInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Lobby = ({
  localTracks, handleLogout, thread, user, videoControls, setInLobby,
}) => {
  const videoRef = useRef();
  const {
    muted, setMuted, cameraOff, setCameraOff,
  } = videoControls;
  const talking = false;

  useEffect(() => {
    if (videoRef.current) {
      localTracks && localTracks.video && localTracks.video.attach(videoRef.current);

      return () => {
        localTracks && localTracks.video && localTracks.video.detach();
      };
    }
  }, [videoRef, localTracks]);
  return (
    <UI.VideoChatContainer>
      <LobbyScreen>
        <div style={{ display: 'flex', flexDirection: 'column' }}>

          <div style={{ display: 'flex' }}>
            <VideoPreviewContainer>
              <div style={{ height: '40vh', width: '40vw' }}>
                <VideoContainer cameraOff={cameraOff} sharing={false} style={{ outline: talking && '2px solid rgb(22 111 190 / 98%)' }}>
                  {talking && <TalkingIcon name='microphone' circular />}
                  {(cameraOff && user)
                    && <UserAvatar user={user} >
                      {(!user?.profile?.avatar && user?.profile.firstName && user?.profile.lastName)
                        && (
                          <span>{user.profile.firstName[0].toUpperCase()}{user.profile.lastName[0].toUpperCase()}</span>
                        )
                      }
                    </UserAvatar>
                  }
                  <VideoDiv
                    style={{ display: cameraOff && 'none' }}
                    autoPlay={true}
                    minimised={false}
                    talking={talking ? 1 : 0}
                    ref={videoRef}
                  />
                  <NameContainer>
                    <span>{user?.profile?.fullName}</span>
                    {muted && <Icon name='microphone slash' size='small' style={{ margin: 'auto', color: 'white', marginLeft: 5 }} />}
                  </NameContainer>
                </VideoContainer>
              </div>
              <div style={{ marginTop: 20 }}>
                <UI.Audio toggleAudio={() => setMuted(!muted)} muted={muted} />
                <UI.Video toggleCamera={() => setCameraOff(!cameraOff)} cameraOff={cameraOff} />
                <UI.Logout leaveRoom={handleLogout} />
              </div>
            </VideoPreviewContainer>
            <ThreadInfoContainer>
              <h2 style={{ color: '#fff' }}>
                {!thread.name && 'Conversation with: '}{thread.name || thread.participantUsers.filter((e) => e._id !== user._id).map((e) => e.profile.fullName).join(', ')}
              </h2>
              <RoundButton primary onClick={() => setInLobby(false)}>
                Join this call
              </RoundButton>
            </ThreadInfoContainer>
          </div>
        </div>
      </LobbyScreen>
    </UI.VideoChatContainer>
  );
};

const mapStateToProps = (state) => ({ user: state.user });

export default connect(
  mapStateToProps,
)(Lobby);
